import { SELECT_ISSUE, DESELECT_ISSUE } from './index';

export default function selectIssue(issue) {
  return (dispatch, getState) => {
    const {
      selectedDevices: { issues },
    } = getState();

    if (issues.some(existing => existing.name === issue.name)) {
      dispatch({ type: DESELECT_ISSUE, issueToRemove: issue });
    } else {
      dispatch({ type: SELECT_ISSUE, issueToAdd: issue });
    }
  };
}
